var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0121933 4.36442L2.39129 0.0574982C2.43152 -0.0191664 2.57011 -0.0191664 2.61034 0.0574982L4.98953 4.36442C5.00481 4.40091 5.00481 4.44109 4.97986 4.47258C4.96042 4.50907 4.92028 4.52661 4.87589 4.52661L0.127315 4.52661C0.0829235 4.52661 0.0427886 4.50898 0.0233513 4.47258C-0.00305072 4.44117 -0.00305167 4.40091 0.0122286 4.36442L0.0121933 4.36442Z",
    fill: "#C1C1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98781 5.63558L2.60871 9.9425C2.56848 10.0192 2.42989 10.0192 2.38966 9.9425L0.0104717 5.63558C-0.00480868 5.59909 -0.00480855 5.55891 0.0201428 5.52742C0.0395818 5.49093 0.0797151 5.47339 0.124106 5.47339L4.87269 5.47339C4.91708 5.47339 4.95721 5.49102 4.97665 5.52742C5.00305 5.55883 5.00305 5.59909 4.98777 5.63558L4.98781 5.63558Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.fd829d66a266860fad49ce79ee8077e4.svg";
export { ForwardRef as ReactComponent };